import { render, staticRenderFns } from "./common-card.vue?vue&type=template&id=b33f3c2c&scoped=true&lang=pug&"
import script from "./common-card.vue?vue&type=script&lang=js&"
export * from "./common-card.vue?vue&type=script&lang=js&"
import style0 from "./common-card.vue?vue&type=style&index=0&id=b33f3c2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33f3c2c",
  null
  
)

export default component.exports